'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OctaneQuiz = function () {
  function OctaneQuiz() {
    (0, _classCallCheck3.default)(this, OctaneQuiz);

    var that = this;

    document.addEventListener('octane.quiz.addToCart', function (e) {
      var variantId = Number(e.detail.items[0].id);
      var quantity = Number(e.detail.items[0].quantity);

      window.PushCart.addItem(variantId, {
        quantity: quantity
      });

      (0, _functional.getElement)('[data-module-drawers-trigger="cart"]').click();
    }, false);

    document.addEventListener('octane.quiz.accessed', function (e) {
      that.replaceResults(e.detail);
    }, false);

    document.addEventListener('octane.quiz.completed', function (e) {
      that.replaceResults(e.detail);
    }, false);
  }

  (0, _createClass3.default)(OctaneQuiz, [{
    key: 'replaceResults',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(data) {
        var resultURL;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // https://www.champohaircare.com/pages/youre-a-kapha
                // https://www.champohaircare.com/pages?preview_key=53c0d3dcdd44f7b9c2dafab3065138c2&preview_theme_id=128997720262#r=PtL60wlGvpUosG9P
                resultURL = '/pages/youre-a-vata';

                if (data.answers['Octane: Quiz results - Champo Quiz'] === 'Kapha') {
                  resultURL = '/pages/youre-a-kapha';
                } else if (data.answers['Octane: Quiz results - Champo Quiz'] === 'Pitta') {
                  resultURL = '/pages/youre-a-pitta';
                }
                // eslint-disable-next-line compat/compat
                fetch(resultURL).then(function (response) {
                  return response.text();
                }).then(function (html) {
                  var doc = new DOMParser().parseFromString(html, 'text/html');
                  var thisMainContent = document.querySelector('#MainContent');
                  var newMainContent = doc.querySelector('#MainContent');

                  var productCards = '';

                  data['product_blocks'][1].forEach(function (element) {
                    var productID = element.id;
                    var productVariantID = element.variants[0].id;
                    var productLink = element.link;
                    var productTitle = element.title;
                    var productTitleFirstWord = productTitle.split(' ')[0];
                    var productPrice = element.price_formatted;
                    var productTag = element.tags.find(function (string) {
                      return string.startsWith('Tag:');
                    });
                    if (productTag) {
                      productTag = productTag.replace('Tag:', '');
                    }
                    var productType = element.type;

                    if (element.tags.indexOf('dosha-Kapha') > -1 && element.tags.indexOf('dosha-Pitta') > -1 && element.tags.indexOf('dosha-Vata') > -1 && window.theme.enableTridoshaMark === true) {
                      productType = 'tridosha';
                    }

                    var productCard = '\n          <div class="prd-Item prd-Item-' + productID + '">\n            <a class="prd-Item_ImageContainer suffix quiz-results-kapha" href="' + productLink + '">\n              <img class="prd-Item_Image" src="' + element.image + '" alt="' + productTitle + '" width="269" height="auto" loading="lazy">\n            </a>\n\n            <form class="prd-Item_Content js-AddToCart" method="post" enctype="multipart/form-data">\n              <input type="hidden" name="id" value="' + productVariantID + '" />\n              <input type="hidden" name="quantity" value="1" />\n\n              <input type="hidden" name="tiktok_content_name" value="' + productTitle + '" />\n              <input type="hidden" name="tiktok_price" value="' + element.price_formatted + '" />\n              <input type="hidden" name="tiktok_value" value="' + element.price_formatted + '" />';

                    if (element.tags.indexOf('bundle') > -1) {
                      productCard += '<input type="hidden" name="properties[_is_bundle]" value="true">';
                    }

                    if (productTag) {
                      productCard += '\n              <div class="prd-Item_ContentHeader">\n                <div class="prd-Item_Tag">\n                  ' + productTag + '\n                </div>\n              </div>\n          ';
                    }

                    productCard += '\n              <div class="prd-Item_ContentBody">\n                <p class="prd-Item_Kicker prd-Item_Kicker-' + productType + '">\n                  <a class="prd-Item_KickerLink" href="' + productLink + '">\n        ';
                    if (productType !== '') {
                      productCard += '' + productType;
                    } else if (productType === 'tridosha') {
                      productCard += '' + productTitleFirstWord;
                    } else {
                      productCard += '&nbsp;';
                    }

                    productCard += '\n                  </a>\n                </p>\n\n                <h3 class="prd-Item_Title">\n                  <a class="prd-Item_TitleLink" href="' + productLink + '">\n        ';

                    if (productType === 'tridosha') {
                      productCard += '' + productTitle.replace(productTitleFirstWord, '');
                    } else {
                      productCard += '' + productTitle;
                    }

                    productCard += '\n                  </a>\n                </h3>\n\n                <p class="prd-Item_Price">\n                  <span class="prd-Item_Price">\n                    ' + productPrice + '\n                  </span>\n                </p>\n\n                <div class="prd-Item_Footer">\n                  <button type="submit"\n                    data-add-to-cart\n                    class="prd-Item_Button btn-Secondary js-AddToCart_Submit">\n                      ' + window.theme.strings.addToCart + '\n                  </button>\n                </div>\n              </div>\n            </form>\n          </div>\n        ';

                    productCards += productCard;
                  });

                  newMainContent.querySelector('.qz-Dosha_ProductsExtra').style.display = 'none';
                  newMainContent.querySelector('#octane-override').innerHTML = productCards;

                  thisMainContent.innerHTML = newMainContent.innerHTML;

                  document.body.scrollTop = 0; // For Safari
                  document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
                }).catch(function (err) {
                  // There was an error
                  console.warn('Something went wrong.', err);
                });

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function replaceResults(_x) {
        return _ref.apply(this, arguments);
      }

      return replaceResults;
    }()
  }]);
  return OctaneQuiz;
}();

exports.default = OctaneQuiz;